export const MY_ISUZU_APP_STORE_URLS = {
  GENERAL: 'https://link.isuzu-tis.com/my-isuzu-app',
  IOS: 'https://link.isuzu-tis.com/my-isuzu-app-ios',
  ANDROID: 'https://link.isuzu-tis.com/my-isuzu-app-android',
} as const;
